module.exports = __webpack_public_path__ + "img/lestream-09032022.a6d29f09.jpg";